import React, { useContext } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Header from './Header';
import ProductCard from './ProductCard';
import { Context} from '../../store/Context';
import { useStore } from '../../store';

const theme = createTheme();

function ProductView({
    add, 
    reset, 
    checkout, 
    removeCategory
}) {   

    const { contextState: {
        products,         
    } } = useContext( Context );	 

	return (
    	<ThemeProvider theme={theme}>
  		<CssBaseline />
  		<Container maxWidth="md">                         
            <main>             
            	<Header                 
            		reset={reset}
            		checkout={checkout}
            	/>
            	<Grid container spacing={1} sx={{mt: 1}}>
                    {products.map( (product, i) => {                    	
                    	return (<ProductCard 
                    		key={i} 
                    		product={product} 
                    		add={add}                     		                    		
                            removeCategory={removeCategory}
                    	/>);
                    })}
                </Grid>
            </main>       
  		</Container>      		
    </ThemeProvider>
  );
}

export default ProductView;